import { u as useTheme$1 } from './emotion-element-6bdfffb2.esm-f2337626.js';
import 'react';

/**
 * Custom hook to get your theme object in React components from ThemeProvider.
 */
var useTheme = function useTheme() {
  return useTheme$1();
};

export { useTheme };
